module.exports = __webpack_public_path__ + "img/btn_post.5c3790a7.png";